export default __webpack_public_path__ + "static/media/pirateShip.8bc1b900.png";